// tslint:disable-next-line:max-line-length
import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, HostListener, ElementRef, ViewChild, OnInit } from '@angular/core';
import { CellEditType } from '../Grid/CellEditType';
import { SortDirection } from '../Grid/sortDirection.enum';
import { IColumn } from '../Grid/column.interface';
import { ICustomer, IPayment } from './customer.class';
import { CustomerService } from '../../services/customer.service';
import { CellFocusEvent } from '../Grid/cellFocus.event';
import { ICellChangedEvent } from '../Grid/cellValueChanged.event';

@Component({
    selector: 'app-customer-detail',
    templateUrl: 'customerDetail.component.html',
    styleUrls: ['customerDetail.component.css']
})

export class CustomerDetailComponent implements OnChanges, OnInit
{
    paymentAmount = 0;
    paymentReference = '';
    message = '';

    @Input() selectedCustomer: ICustomer;
    @Output() customerSelect = new EventEmitter<ICustomer>();

    @ViewChild('title') title: ElementRef;

    constructor(private el: ElementRef, private customerService: CustomerService)
    {
    }

    addPayment()
    {
        let payment: IPayment = {
            customerId: this.selectedCustomer.customerId,
            amount: this.paymentAmount,
            reference: this.paymentReference
        };

        this.customerService.addPayment(payment).then( cust => {
            this.selectedCustomer = cust;
        });
    }

    ngOnInit()
    {
    }

    ngOnChanges(changes: SimpleChanges)
    {
    }
}



// WEBPACK FOOTER //
// ./src/app/components/Customer/customerDetail.component.ts